export default __webpack_public_path__ + "static/media/a5.f5a89911.svg";